import './App.css';
import { useState, useEffect } from 'react';
import Tesseract from "tesseract.js";
import aiImage from './aiiamge.jpg';
import OpenAI from 'openai';
import { toast, Toaster } from "sonner";
import { GoogleGenerativeAI } from "@google/generative-ai";
import {  ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

const tableStyle = {
  borderCollapse: "collapse",
  marginTop: "10px",
  margin:"5px"
};

const cellStyle = {
  border: "1px solid #ccc",
  padding: "6px",
  textAlign: "center",
  fontSize: "12px",
  minWidth: "20px",
  cursor:"pointer"
};
const GEMINI_API_KEY='AIzaSyAQUinwSkCaFPCZkbE71JJcZd3fbJhVrME'
const OPENAI_API_KEY='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'
//'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'

const OPENAI_API_KEY2='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'

//'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'

function App() {
  const [images, setImages] = useState([]); // array of files
  const [previews, setPreviews] = useState([]); // URLs for preview
  const [loading, setLoading] = useState("false");
  const [numbers, setNumbers] = useState([]);
  const [count, setCount] = useState(null);
  const [hoveredNumber, setHoveredNumber] = useState(null);
  const[frequencyList,setFrequencyList]=useState([])
  const[currentCol,setCurrentCol]=useState(0)

  // Generate preview URLs whenever images array changes
  useEffect(() => {
    const urls = images.map(file => URL.createObjectURL(file));
    setPreviews(urls);

    // Cleanup old URLs to prevent memory leaks
    return () => urls.forEach(url => URL.revokeObjectURL(url));
  }, [images]);

  // File input handler
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if(images.length<5){
    setImages(prev => [...prev, file]); // append to existing images
    e.target.value = ""; }
    else{
      toast.error("You can only upload 5 image at once")
    }
  };

  // Table helper
  const chunkArray = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };
  const data = Array.from({ length: 500 }, (_, i) => i + 1);
  let rows = chunkArray(data, 10);

  let ocrRunning = false;
  let ocrUplad = false;

  // ------------------------
  // Image preprocessing

  const genAI = new GoogleGenerativeAI(GEMINI_API_KEY);
 

  // ------------------------
  // OCR per image

const client1 = new OpenAI({
  apiKey: OPENAI_API_KEY,
  dangerouslyAllowBrowser: true,
});

const client2 = new OpenAI({
  apiKey: OPENAI_API_KEY2,
  dangerouslyAllowBrowser: true,
});

const fileToDataURL = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result); // full data URL
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      // REMOVE prefix here
      const base64 = reader.result.split(",")[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

    const getFrequencyList = (list) => {
    const map = {};

    list.forEach((val) => {
      const num = Number(val);
      if (!isNaN(num)) {
        map[num] = (map[num] || 0) + 1;
      }
    });

    return Object.entries(map)
      .map(([number, frequency]) => ({
        number: Number(number),
        frequency,
      }))
      .sort((a, b) => b.frequency - a.frequency);
  };

const showToast = () => {
  setTimeout(() => {
    toast.info("It may take few minutes to get response from AI ...so wait");
  }, 8000); // 5000ms = 5 seconds
};


const                     recognizeNumbersFromImage = async (files) => {
    const imageUrls = await Promise.all(
    files.map((file) => fileToDataURL(file))
  );

   if (ocrRunning) {
    console.warn("OCR already running — blocked");
    return;
  }

    ocrRunning = true;
   toast.info("Ai is reading your images")

   const content = [
    {
      type: "input_text",
      text:
        "Extract all numbers visible in each image. " +
        "Return one line per image. " +
        "Each line should contain ONLY numbers separated by spaces.",
    },
    ...imageUrls.map((url) => ({
      type: "input_image",
      image_url: url,
    })),
  ];
  try {
   


 console.log("one time",);
 showToast()

  const response = await client1.responses.create({
    model: "gpt-4.1-mini",
    input: [
      {
        role: "user",
        content,
      },
    ],
    
  });
  console.log("one time",response);
  
  const text = response.output_text || "";
  toast.success("Numbers are extracted from your image")
  return text.trim().split(/\s+/).filter(Boolean);
  } catch (error) {
    console.log(error);


    // in case daily limit exceeds for one key

    try {
        const response = await client2.responses.create({
    model: "gpt-4.1-mini",
    input: [
      {
        role: "user",
        content,
      },
    ],
    
  });
  console.log("one time");
  
  const text = response.output_text || "";
  toast.success("Numbers are extracted from your image")
  return text.trim().split(/\s+/).filter(Boolean);
    } catch (error) {
     toast.error("Try to upload after few times.... limit exceeds")
     return "" 
    }
   
    
  } finally {
    setTimeout(() => {
      ocrRunning = false;
    },2000); // match RPM window
  }




  
  
};


    const handleImageUpload = async () => {
   

    setLoading('true');

      if (ocrUplad) {
    console.warn("OCR already running — blocked");
    return;
  }
 

    try {
      const allNumbers = [];
      console.log("starting..");
 ocrUplad=true
 // only to get column number
       const imageUrl = await fileToBase64(images[0]);
       

const model = genAI.getGenerativeModel({
  model: "gemini-2.5-flash",
});

try {
  const result = await model.generateContent([
  {
    text: `
Look at the image.
Focus ONLY on the FIRST ROW.
Count how many distinct columns (cells) are present in that row.Do not make mistake, count carefully
Return ONLY a single integer.
No explanation.
`
  },
  {
    inlineData: {
      mimeType: "image/png", // or image/jpeg
      data: imageUrl.replace(/^data:image\/\w+;base64,/, ""),
    },
  },
]);
const output = result.response.text();
console.log("columns-----",output);
setCurrentCol(Number(output))  
} catch (error) {
  console.log(error);
  alert("Failed to read column, 10 by default")
  setCurrentCol(10)
}



//{ const response = await fetch(
//   `https://generativelanguage.googleapis.com/v1/models/models/gemini-2.5-flash:generateContent?key=${GEMINI_API_KEY}`,
//   {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({
//       contents: [
//         {
//           parts: [
//             {
//               text: `
// Look at the image.
// Focus ONLY on the FIRST ROW.
// Count how many distinct columns (cells) are present in that row.
// Return ONLY a single integer.
// No explanation.
// `,
//             },
//             {
//               inlineData: {
//                 mimeType: "image/png", // or image/jpeg
//                 data: imageUrl,
//               },
//             },
//           ],
//         },
//       ],
//     }),
//   }
// );

// const data = await response.json();
// console.log(data);




// const output =
//   data.candidates?.[0]?.content?.parts?.[0]?.text?.trim();



//    console.log("column present",Number(responseCol.output_text)-1);
//  setCurrentCol(Number(responseCol.output_text)-1)
       
//return}
      
        const nums = await recognizeNumbersFromImage(images);
     
        setLoading('true')
      

      console.log(nums);
      

      const freq = getFrequencyList(nums);
      setFrequencyList(freq)
     
      setNumbers(nums)
      console.log("list of nums",nums);
      
    } catch (err) {
      console.error("OCR failed:", err);
     
    } finally {
      setLoading('false');
       setTimeout(() => {
      ocrUplad = false;
    }, 20_000); 
    }
  };


// const preprocessImage = async (file) => {
//   const img = new Image();
//   img.src = URL.createObjectURL(file);
//   await img.decode();

//   const canvas = document.createElement("canvas");
//   canvas.width = img.width;
//   canvas.height = img.height;
//   const ctx = canvas.getContext("2d");
//   ctx.drawImage(img, 0, 0);

//   const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
//   const data = imageData.data;

//   for (let i = 0; i < data.length; i += 4) {
//     const r = data[i];
//     const g = data[i + 1];
//     const b = data[i + 2];

//     // Preserve red, green, white numbers
//     const maxChannel = Math.max(r, g, b);
//     const value = maxChannel > 80 ? 255 : 0;

//     data[i] = data[i + 1] = data[i + 2] = value;
//   }

//   ctx.putImageData(imageData, 0, 0);
//   return canvas;
// };

//  const flattenNumbers = (ocrLines) => {
//   return ocrLines
//     .map(line => line.trim().split(/\s+/)) // split each line into array
//     .flat();                               // flatten all arrays into one
// };

//   // Process all images


//   const handleImageUpload = async () => {
//   if (!images || images.length === 0) return;
//   setLoading("true");

//   try {
//     const allLinesPerImage = [];
//   const allNumbers = [];
//   for (const file of images) {
//     const nums = await recognizeNumbers(file);
//     allNumbers.push(...nums);
//     setLoading("true")
//   }

//   const flatArray = flattenNumbers(allNumbers);
//   console.log(flatArray);

// setNumbers(flatArray)

// let frequenctTable=getFrequencyList(flatArray)
// setFrequencyList(frequenctTable)


//   } catch (err) {
//     console.error("OCR failed:", err);
//   } finally {
//     setLoading("false");
//   }
// };

// const recognizeNumbers = async (file) => {
//   const canvas = await preprocessImage(file);
//   setLoading('detecting')

//   const { data } = await Tesseract.recognize(canvas, "eng", {
//     tessedit_char_whitelist: "0123456789=+-*/ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
//     tessedit_pageseg_mode: Tesseract.PSM.SINGLE_BLOCK,
//   });

//   // Split by line and filter empty
//   const numbers = data.text
//     .split(/\n/)
//     .map(line => line.trim())
//     .filter(line => line.length > 0);

//   return numbers;
// };



useEffect(() => {

 const counter=  numbers.filter(i=>i===JSON.stringify(hoveredNumber))

 setCount(counter.length)
}, [numbers,hoveredNumber])


// function getFrequencyList(list) {
//   const frequencyMap = {};

//   list.forEach((value) => {
//     const num = Number(value);
//     frequencyMap[num] = (frequencyMap[num] || 0) + 1;
//   });

//   return Object.entries(frequencyMap)
//     .map(([number, frequency]) => ({
//       number: Number(number),
//       frequency
//     }))
//     .sort((a, b) => b.frequency - a.frequency); // DESC order
// }


  return (
    <div className="App" style={{
      position: "relative",
      minHeight: "100vh",
      height: "100vh",
      color: "#fff",
      padding: "20px",
      backgroundImage: `url(${aiImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      overflow: "hidden"
    }}>
        

        <Toaster position="top-right" richColors />
      {/* Overlay */}
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backdropFilter: "blur(8px)",
        backgroundColor: "rgba(0,0,0,0.3)",
        zIndex: 1,
      }}></div>

      {/* Content */}
      <div style={{ width: "100%", height: "100%", zIndex: 2, position: "relative", top: 0 }}>
        <p style={{position:"fixed",top:0,left:0,zIndex:200, fontSize: "30px", fontWeight: "700", padding: "5px", borderBottom: "2px solid white", margin: 0,backgroundColor:"black",width:"120vw" }}>
          Give image and AI will count the number frequency ~
        </p>

        <div style={{ width: "100%", height: "110vh", zIndex: 2, position: "relative", display: "flex", padding: "10px",marginTop:"50px" }}>
          {/* Left Section */}
          <div style={{ width: "65%", borderRight: "1px solid white" }}>
            <div style={{ width: "100%", display: "flex", justifyContent: "center", gap: "20px" }}>
              <div style={{
                     padding: "10px",
                     borderRadius: "8px",
                     border: "1px solid white",
                     width: "50%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "20px",

                      /* added */
                      background: "rgba(255, 255, 255, 0.1)",
                      backdropFilter: "blur(10px)",
                      WebkitBackdropFilter: "blur(10px)", // Safari support
                      boxShadow: "0 8px 25px rgba(0, 0, 0, 0.25)",
                    }}>
                <label style={{ fontSize: "20px", fontWeight: "600" }}>Select 5 images one by one <br />
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    style={{
                      height: "25px",
                      border: "0.5px solid grey",
                      color: "black",
                      backgroundColor: "white",
                      borderRadius: "6px",
                      width: "200px",
                    }}
                    onChange={handleFileChange}
                  />
                </label>

                {loading==="false"?<button onClick={handleImageUpload}
                  style={{
                    width: "100px",
                    padding: "10px",
                    borderRadius: "8px",
                    backgroundColor: "#111e31ff",
                    color: "#ffffff",
                    fontWeight: "600"
                  }}>Submit</button>:
                  <button 
                  style={{
                    width: "100px",
                    padding: "10px",
                    borderRadius: "8px",
                    backgroundColor: "#111e31ff",
                    color: "#ffffff",
                    fontWeight: "600",
                    cursor:"not-allowed"
                  }}>Working...</button>
                  }
              </div>
            </div>

            {/* Preview */}
            {previews.length > 0 && (
              <div style={{ height: "250px", width: "100%", marginTop: "40px",marginRight:"20px" ,border:"1px solid white",overflowY:"auto",position:"relative",borderRadius:"10px",backgroundColor:"#cccaca"}}>
                <p style={{position:"absolute",top:"-10px",right:0,width:"30px",height:"30px",backgroundColor:"#474747ff",borderRadius:"50%",cursor:"pointer",zIndex:100}}
                  onClick={()=>{setImages([]);setNumbers([])}}>X</p>
                <div style={{
                  display: "flex",
                flexWrap:"wrap",
                  gap: "10px",
                  overflowlowY:"auto",
                  position:"relative"
                }}>
                 
                  {previews.map((src, index) => (
                    <img key={index} src={src} style={{ width: "140px", height: "150px", objectFit: "fill",margin:"10px" }} alt={`uploaded-${index}`} />
                  ))}
                </div>
              </div>
            )}

            {/* Loading */}
            {loading === "detecting" && <p style={{ fontSize: "25px", fontWeight: "600" }}>Processing your images, please wait…</p>}
            {loading === "true" && <p style={{ fontSize: "25px", fontWeight: "700",  color: "white", // text color
    textShadow: "2px 2px 4px grey" }}>Generating Answer, please wait…....</p>}
             {(loading === "false"&&numbers.length < 1) && <p style={{ fontSize: "18px", fontWeight: "600",  color: "white", // text color
    textShadow: "3px 3px 6px #ffffff" }}>Note: Try to upload clean and cropped image one by one<br/>
             Maximum 5 image can be upload to at a time<br/>
             Note:Maximum 10 times per day request is acceptable for free use</p>}

            {/* OCR Results */}
            {(numbers.length > 0) && (
              <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center",margin:0,padding:0 }}>
                <p style={{fontSize:"25px",fontWeight:"700",marginBottom:"10px",padding:0 }}>There are total <span style={{color:"#13cefdff"}}>{count}</span> number of  {hoveredNumber} present</p>

                
              </div>
            )}


          { numbers.length > 0 && <div 
            style={{width:"90%",height:"140px",backgroundColor:"#3d3d3dff",overflowX:"auto",padding:"5px",borderRadius:"6px",}}>
             

                 <table style={tableStyle}>
  <thead>
    <tr>
      <th style={cellStyle}>Numbers</th>
      {frequencyList.map((item) => (
        <th key={item.number} style={cellStyle}
           onMouseEnter={() => setHoveredNumber(Number(item.number))}
                      onMouseLeave={() => setHoveredNumber(null)}>
          <p style={{margin:0,padding:0,border:Number(hoveredNumber)===item.number?"0.1px solid #08f4fcff":"0.1px solid #444444ff",borderRadius:"5px"}}>{item.number}</p>
        </th>
      ))}
    </tr>
  </thead>

  <tbody>
    <tr>
      <td style={cellStyle}>Frequency</td>
      {frequencyList.map((item) => (
        <td key={item.number} style={cellStyle}
         onMouseEnter={() => setHoveredNumber(Number(item.number))}
                      onMouseLeave={() => setHoveredNumber(null)}>
         <p style={{margin:0,padding:0,border:Number(hoveredNumber)===item.number?"0.1px solid #08f4fcff":"0.1px solid #444444ff",borderRadius:"5px"}}>  {item.frequency}</p>
        </td>
      ))}
    </tr>
  </tbody>
                  </table>


            </div>}

            
          </div>

          {/* Right Section Table */}
          <div style={{
            padding: "5px",
            width: "30%",
            border: "2px solid white",
            borderRadius: "10px",
            margin: "0px 40px",
            height: "86vh",
            backgroundColor: "#2c2b2bff",
            display: "flex",
            alignItems: "start",
            justifyContent: "center",
            overflowY:"auto"
          }}>
           
            <table style={{ borderCollapse: "collapse", width: "80%", height: "40%" ,overflowY:"auto"}}>
              <tbody>
                {chunkArray(numbers, currentCol).map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {row.map((cell, colIndex) => (
                      <td key={colIndex} style={{ fontSize: "8px", textAlign: "center" ,cursor:"pointer"}}
                      onMouseEnter={() => setHoveredNumber(Number(cell))}
                      onMouseLeave={() => setHoveredNumber(null)}>
                       <p style={{margin:0,padding:"1.2px",border:hoveredNumber===Number(cell)?"0.1px solid #08f4fcff":"0.1px solid #444444ff",borderRadius:"4px"}}> {cell}</p>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
